import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';
import Hosts from '../../../Hosts'
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

	//get_vat_info,
	repo_banner_link,

	pattern_vat,
	pattern_email,
	passwordHash,

} from '../../../Utils';

import { language } from './Language';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import endOfDecadeWithOptions from 'date-fns/esm/fp/endOfDecadeWithOptions';



export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);

	const [lang, /*set_lang*/] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [is_input_disabled, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	//const [newDate, ] = useState(new Date())
	//const [today , ] = useState(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0"))

	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');

	const [/*disabled*/, set_disabled] = useState(false)

	const entity_types = [
		{ value: "Ski", label: "Ski" },
		{ value: "Snowboard", label: "Snowboard" }
	];

	const identification_types = [
		{ value: "Bilhete de Identidade", label: "Bilhete de Identidade" },
		{ value: "Cartão de Cidadão", label: "Cartão de Cidadão" }
	];

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
		}),
	}

	// Nome:Tipo
	const tipoSw = [
		{ id: 1, nome: 'SimAlimentação' },
		{ id: 2, nome: 'SimPan' },
		{ id: 3, nome: 'SimFact' },
		{ id: 4, nome: 'SimBeet' },
		{ id: 5, nome: 'SimRest' }
	];

	//Linha:SW

	const linhaSw = [
		{ id: 1, nome: 'Base' },
		{ id: 2, nome: 'Extra' },
		{ id: 3, nome: 'Light' },

	];

	const prioridadeMap = {
		1: { name: 'Imediato', color: '#ff4d4f' }, // Red
		2: { name: 'Urgente', color: '#fa8c16' }, // Orange
		3: { name: 'Pouco Urgente', color: '#ffec3d' }, // Yellow
		4: { name: 'Não Urgente', color: '#52c41a' } // Green
	};

	const lineBreak = {
		maxWidth: '200px', /* Adjust the width as needed */
		wordWrap: 'break-word', /* Allows long words to break and wrap onto the next line */
		overflowWrap: 'break-word', /* Ensures long words break and wrap */
		hyphens: 'auto', /* Optional: Adds hyphenation for better word breaking */
	};

	/////////////////////////////////////////////////////////////////////////////////////////////////////

	const [departamentoInput, setDepartamentoInput] = useState('');
	const [responsavelInputNome, setresponsavelInputNome] = useState('');
	const [responsavelInputTel, setresponsavelInputTel] = useState('');
	const [responsavelInputEmail, setresponsavelInputEmail] = useState('');
	const [responsavelInputObs, setresponsavelInputObs] = useState('');
	const [departamentoId, setDepartamentoId] = useState();
	const [selectedDepartamentoId, setSelectedDepartamentoId] = useState('');
	const [ticketId, setTicketId] = useState('');
	const [prioridade, setPrioridade] = useState('4');
	const [dataTicket, setDataTicket] = useState('');
	const [selectedClienteId, setSelectedClienteId] = useState('');
	const [selectedColaboradorId, setSelectedColaboradorId] = useState('');
	const [assuntoInput, setAssuntoInput] = useState('');
	const [selectedResponsavelId, setSelectedResponsavelId] = useState('');
	const [newTicket, setNewTicket] = useState(dados.current.info.ticket || []);
	const [solucaoInput, setSolucaoInput] = useState('');
	const [modalResponsavel, setModalResponsavel] = useState(false);
	const [modalDepartamento, setModalDepartamento] = useState(false);
	const [modalPedidoAssistencia, setModalPedidoAssistencia] = useState(false);
	const [modalPedidoSolucao, setModalPedidoSolucao] = useState(false);
	const [tabelaPedidos, setTabelaPedidos] = useState(true);
	const [tabelaConcluidos, setTabelaConcluidos] = useState(false);

	// STATES PARA  PARA PROJETOS
	const [selectedProjectId, setSelectedProjectId] = useState('');
	const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
	const [codProjetoInput, setCodProjetoInput] = useState('');
	const [tipoIdInput, setTipoIdInput] = useState(1);
	const [linhaIdInput, setLinhaIdInput] = useState(1);
	const [nLicencaInput, setNLicencaInput] = useState('');
	const [dataInicioInput, setDataInicioInput] = useState('');
	const [dataFimInput, setDataFimInput] = useState('');
	const [assistenciaRemotaInput, setAssistenciaRemotaInput] = useState(false);
	const [tempoAssistenciaInput, setTempoAssistenciaInput] = useState('');
	const [assistenciaPermitidaInput, setAssistenciaPermitidaInput] = useState(false);
	const [refresh, setRefresh] = useState(0);
	const [projetoAtual, setProjetoAtual] = useState(null);
	const [tickets, setTickets] = useState(dados.current.info.ticket || []);
	const [selectedTicket, setSelectedTicket] = useState(null);
	const [selectedTicketId, setSelectedTicketId] = useState(null);
	const [estado, setEstado] = useState(false);
	const [colaboradorNome, setSelectedColaboradorNome] = useState('');
	const [emailResponsavel, setEmailResponsavel] = useState('');
	/*
	const getTicketById = (id) => {
		return dados.current.info.ticket.find(ticket => ticket.id === id);
	}

	const handleCloseModal = () => {
		setModalPedidoSolucao(false);
		setSelectedTicket(null);
	};


	const handleSelectDepartamento = (event) => {
		setSelectedDepartamentoId(event.target.value);
	};

	const handleChangeDepartamento = (event) => {
		const { name, value } = event.target;
		set_dados((prevState) => ({
			...prevState,
			current: {
				...prevState.current,
				info: {
					...prevState.current.info,
					[name]: value,
				},
			},
		}));
	};
	*/

	//////////////////////////////////////////////////////Parte do email ///////////////////////////////////////////
	function armazenarCampos(ticketAtualizado) {
		// Cliente
		const clienteId = ticketAtualizado.clienteId;
		const clienteNome = ticketAtualizado.cliente.nome;
		const clienteEmail = ticketAtualizado.cliente.email;

		// Colaborador
		const colaboradorId = ticketAtualizado.colaborador.id;
		const colaboradorNome = ticketAtualizado.colaborador.nome;
		const colaboradorEmail = ticketAtualizado.colaborador.email;
		const colaboradorTelefone = ticketAtualizado.colaborador.mobile_phone;

		// Outros campos do ticket
		const data = ticketAtualizado.data;
		const descricao = ticketAtualizado.descricao;
		const estado = ticketAtualizado.estado;
		const id = ticketAtualizado.id;
		const prioridade = ticketAtualizado.prioridade;
		const solucao = ticketAtualizado.solucao;

		// Projeto
		const projetoId = ticketAtualizado.projetoId;
		const projetoNome = ticketAtualizado.projeto.nome[0];  // Supondo que 'nome' seja um array, como na imagem
		const dataFimProjeto = ticketAtualizado.projeto.dataFim;
		const nLicencaProjeto = ticketAtualizado.projeto.nLicenca;
		const codProjeto = ticketAtualizado.projeto.codProjeto;

		// Responsável
		const responsavelId = ticketAtualizado.responsavelId;
		const responsavelNome = ticketAtualizado.responsavel.name;
		const responsavelEmail = ticketAtualizado.responsavel.email;
		const responsavelObservacao = ticketAtualizado.responsavel.observation;
	}

	function enviarEmail(ticket) {
		const emailResponsavel = ticket.responsavel ? ticket.responsavel.email : '';
		const responsavel = dados.current.contacts[0].person_responsables.find(resp => parseInt(resp.id) === parseInt(selectedResponsavelId));
		const prioridade = ticket.prioridade;
		const cliente = dados.current.contacts[0].clientes.find(cliente => parseInt(cliente.id) === parseInt(selectedClienteId));
		const nomeCliente = cliente ? cliente.nome : 'Cliente não encontrado';
		const assunto = decodeURIComponent(assuntoInput);
		const projeto = dados.current.info.projetos.find(proj => parseInt(proj.id) === parseInt(selectedProjectId));

		let tipoProjeto = 'Tipo Indisponível';
		let linhaProjeto = 'Linha Indisponível';

		if (projeto && projeto.nome && projeto.nome.length > 0) {
			tipoProjeto = projeto.nome[0].tipo?.nome || 'Tipo Indisponível';
			linhaProjeto = projeto.nome[0].linha?.nome || 'Linha Indisponível';
		}
		const nomeProjeto = tipoProjeto + ' ' + linhaProjeto;

		const prioridadeLabel = {
			'1': 'Imediato',
			'2': 'Urgente',
			'3': 'Pouco Urgente',
			'4': 'Não Urgente'

		}[prioridade];

		let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + ';border:1px solid transparent;border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
			'<div style="padding-bottom: 20px; font-size: 18px; font-weight: bold; color:' + Hosts.EMAIL_HEADING_COLOR + ';">' +
			'Atenção Solicitada: ' +
			'</div>' +
			'<div style="padding-bottom: 20px; color: #333; font-size: 16px; line-height: 1.6;">' +
			assunto +
			'</div>' +
			'<div style="padding-bottom: 20px; font-size: 16px;">' +
			'<span style="font-weight: bold;">Prioridade:</span> ' +
			'<span style="color: ' + (prioridadeLabel === 'Imediato' ? '#7b241c' : prioridadeLabel === 'Urgente' ? '#cb5201 ' : prioridadeLabel === 'Pouco Urgente' ? '#b7950b' : prioridadeLabel === 'Não Urgente' ? '#52c41a' : Hosts.EMAIL_TEXT_COLOR) + ';">' + prioridadeLabel + '</span>' +
			'</div>' +
			'<div style="padding-top: 20px; font-size: 16px; line-height: 1.6; border-top: 1px solid ' + Hosts.EMAIL_TEXT_COLOR + ';">' +
			'Com os melhores cumprimentos,<br/>' +
			'ASSEC' +
			'</div>' +
			'</td>' +
			'</tr>' +
			'</table>';

		const mailHtmlTop = '<html><head><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet"> </head><body style="background-color:' + Hosts.EMAIL_BODY_BACKGROUND_COLOR + '; font-family:poppins, helvetica, arial, sans-serif; ">' +
			'<div style="width:100% !important; margin-top:0; margin-bottom:0; margin-right:0; margin-left:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; color:' + Hosts.EMAIL_TEXT_COLOR + ';">' +
			'<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0; margin-bottom:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td style="border-collapse: collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + ';">' +
			'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
			'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
			'<img style="width: 600px;" width="600" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
			'</a>' +
			'</td>' +
			'</tr>' +
			'</table>'

		const mailHtmlBottom = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.FOOTER_EMAIL_COLOR + '; padding: 10px; border: 1px solid transparent; border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td align="left" style="padding-bottom: 10px; padding-top: 10px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + ';">' +
			'<div>' +
			'<div style="text-align: center; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + '; color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR + ';">' +
			'<span style="text-transform: uppercase;">' + Hosts.webSiteTitle + '</span>' +
			'<br/>' +
			'<span>' + Hosts.webSiteAdress + '</span>' +
			'<br/>' +
			'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" style="font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + ';"> ' +
			'<span style="color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR + ';font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + '; text-decoration: underline" >' + Hosts.EMAIL_WEB_SITE_URL + '</span>' +
			'</a>' +
			'</div>' +
			'</div>' +
			'</td>' +
			'</tr>' +
			'</table>' +
			'</td>' +
			'</tr>' +
			'</table>' +
			'</div>' +
			'<body>' +
			'<html>'

		let mailOptions = {
			from: 'web.dev@assec.pt',
			to: emailResponsavel,
			subject: `Caro ${responsavel?.name} da empresa ${nomeCliente}, referente ao projeto ${nomeProjeto} `,
			html: mailHtmlTop + mail_content + mailHtmlBottom,
		};

		reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions });
	}

	function enviarEmailConcluido(ticketAtualizado) {

		const emailResponsavel = ticketAtualizado.responsavel ? ticketAtualizado.responsavel.email : '';
		const nomeColaborador = ticketAtualizado.colaborador ? ticketAtualizado.colaborador.nome : '';

		let tipoProjeto = 'Tipo Indisponível';
		let linhaProjeto = 'Linha Indisponível';

		if (ticketAtualizado.projeto && ticketAtualizado.projeto.nome && ticketAtualizado.projeto.nome.length > 0) {
			tipoProjeto = ticketAtualizado.projeto.nome[0].tipo?.nome || 'Tipo Indisponível';
			linhaProjeto = ticketAtualizado.projeto.nome[0].linha?.nome || 'Linha Indisponível';
		}

		const nomeProjetoteste = tipoProjeto + ' ' + linhaProjeto;

		const solucao = decodeURIComponent(solucaoInput);
		const descricao = ticketAtualizado.descricao;
		const assunto = decodeURIComponent(descricao);

		let mail_content =
			'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + ';border:1px solid transparent;border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td align="left" style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
			'<div style="padding-bottom: 20px; font-size: 18px; font-weight: bold; color:' + Hosts.EMAIL_HEADING_COLOR + ';">' +
			'A atenção solicitada: ' +
			'</div>' +
			'<div style="padding-bottom: 20px; color: #333; font-size: 16px; line-height: 1.6;">' +
			assunto +
			'</div>' +
			'<div style="padding-bottom: 20px; font-size: 18px; font-weight: bold; color:' + Hosts.EMAIL_HEADING_COLOR + ';">' +
			'Teve a solução ao problema: ' +
			'</div>' +
			'<div style="padding-bottom: 20px; color: #333; font-size: 16px; line-height: 1.6;">' +
			solucao +
			'</div>' +
			'<div style="padding-top: 20px; font-size: 16px; line-height: 1.6; border-top: 1px solid ' + Hosts.EMAIL_TEXT_COLOR + ';">' +
			'Com os melhores cumprimentos,<br/>' +
			nomeColaborador +
			'<br/>' +
			'ASSEC' +
			'</div>' +
			'</td></tr></table>';

		const mailHtmlTop = '<html><head><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet"> </head><body style="background-color:' + Hosts.EMAIL_BODY_BACKGROUND_COLOR + '; font-family:poppins, helvetica, arial, sans-serif; ">' +
			'<div style="width:100% !important; margin-top:0; margin-bottom:0; margin-right:0; margin-left:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; color:' + Hosts.EMAIL_TEXT_COLOR + ';">' +
			'<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0; margin-bottom:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td style="border-collapse: collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + ';">' +
			'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
			'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
			'<img style="width: 600px;" width="600" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
			'</a>' +
			'</td>' +
			'</tr>' +
			'</table>'

		const mailHtmlBottom = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.FOOTER_EMAIL_COLOR + '; padding: 10px; border: 1px solid transparent; border-collapse:collapse;">' +
			'<tr style="border-collapse: collapse;">' +
			'<td align="left" style="padding-bottom: 10px; padding-top: 10px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + ';">' +
			'<div>' +
			'<div style="text-align: center; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + '; color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR + ';">' +
			'<span style="text-transform: uppercase;">' + Hosts.webSiteTitle + '</span>' +
			'<br/>' +
			'<span>' + Hosts.webSiteAdress + '</span>' +
			'<br/>' +
			'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" style="font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + ';"> ' +
			'<span style="color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR + ';font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + '; text-decoration: underline" >' + Hosts.EMAIL_WEB_SITE_URL + '</span>' +
			'</a>' +
			'</div>' +
			'</div>' +
			'</td>' +
			'</tr>' +
			'</table>' +
			'</td>' +
			'</tr>' +
			'</table>' +
			'</div>' +
			'<body>' +
			'<html>'

		let mailOptions = {
			from: 'web.dev@assec.pt',
			to: emailResponsavel,
			subject: `Caro ${ticketAtualizado.responsavel.name} da empresa ${ticketAtualizado.cliente.nome}, referente ao projeto ${nomeProjetoteste} `,
			html: mailHtmlTop + mail_content + mailHtmlBottom,
		};

		reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions });
	}

	const mostrarTicket = (ticketId) => {
		setModalPedidoSolucao(true);
		setSelectedTicketId(ticketId);  // Armazena o ID do ticket selecionado		
		const ticket = dados.current.info.ticket.find(ticket => ticket.id === ticketId);
		if (ticket) {
			setSolucaoInput(ticket.solucao || '');  // Inicializa com a solução do ticket
		}
	};

	const atualizarTicketEstado = (solucao) => {
		if (!selectedTicketId || !selectedColaboradorId) {
			return;
		}

		const ticketId = selectedTicketId;
		const colaboradorId = selectedColaboradorId;

		if (!dados.current || !dados.current.info || !dados.current.info.ticket) {
			return;
		}

		const ticketIndex = dados.current.info.ticket.findIndex(ticket => ticket.id === ticketId);

		if (ticketIndex !== -1) {
			const colaborador = dados.current.contacts && dados.current.contacts[0] && dados.current.contacts[0].colaborador
				? dados.current.contacts[0].colaborador.find(colaborador => parseInt(colaborador.id) === parseInt(colaboradorId))
				: null;


			const ticketAtualizado = {
				...dados.current.info.ticket[ticketIndex],
				estado: true,
				solucao: solucaoInput,
				colaborador: colaborador || null
			};

			const selectedResponsavel = dados.current.contacts[0].person_responsables.find(resp => parseInt(resp.id) === parseInt(selectedResponsavelId));

			setEmailResponsavel(selectedResponsavel ? selectedResponsavel.email : '');

			dados.current.info.ticket[ticketIndex] = ticketAtualizado;

			enviarEmailConcluido(ticketAtualizado);
			armazenarCampos(ticketAtualizado);
		} else {
			console.log("Ticket não encontrado com ID:", ticketId);
		}

		setModalPedidoSolucao(false);
		setSolucaoInput('');

	};

	const toggleTablePedidos = () => {
		setTabelaPedidos(!tabelaPedidos);
		setTabelaConcluidos(!tabelaConcluidos);
	};

	const toggleTableConcluidos = () => {
		setTabelaConcluidos(!tabelaConcluidos);
		setTabelaPedidos(!tabelaPedidos);
	};

	const handleAddDepartamento = () => {
		let aux = dados.current.contacts[0].departamentos
		let last = dados.current.contacts[0].departamentos[dados.current.contacts[0].departamentos.length - 1];

		if (departamentoInput) {
			aux.push({ id: last.id + 1, nome: departamentoInput })
			setDepartamentoInput('');
			setModalDepartamento(false);
		}
		set_dados(dados.current.contacts[0].departamentos = aux)
	};

	const handleAddResponsavel = () => {
		const departamentoId = String(selectedDepartamentoId);
		const departamentoIndex = dados.current.contacts[0].departamentos.findIndex(dept => String(dept.id) === departamentoId);

		let aux = dados.current.contacts[0].person_responsables;
		let last = dados.current.contacts[0].person_responsables[dados.current.contacts[0].person_responsables.length - 1];

		if (responsavelInputNome && responsavelInputTel) {
			const newResponsavel = {
				id: last ? String(parseInt(last.id) + 1) : '1',
				name: responsavelInputNome,
				email: responsavelInputEmail,
				mobile_phone: responsavelInputTel,
				departamentos: [parseInt(departamentoId)]
			};

			aux.push(newResponsavel);

			if (departamentoIndex !== -1) {
				const departamento = dados.current.contacts[0].departamentos[departamentoIndex];
			}

			const updatedDados = {
				...dados.current,
				contacts: [{
					...dados.current.contacts[0],
					person_responsables: aux
				}]
			};

			localStorage.setItem('dados', JSON.stringify(updatedDados));

			setModalResponsavel(false);

			set_dados(updatedDados);
		}
	};

	/*   MÉTODO DO TICKET            */

	const addTicket = () => {
		if (!dados.current.info) {
			dados.current.info = {};
		}

		if (!Array.isArray(dados.current.info.ticket)) {
			dados.current.info.ticket = [];
		}

		const existingTicketIndex = dados.current.info.ticket.findIndex(ticket => ticket.id === parseInt(newTicket.id));

		if (existingTicketIndex !== -1) {
			dados.current.info.ticket[existingTicketIndex] = {
				...dados.current.info.ticket[existingTicketIndex],
				prioridade: prioridade,
				data: getCurrentDateTime(),
				descricao: assuntoInput,
				clienteId: selectedClienteId,
				responsavelId: selectedResponsavelId,
				projetoId: selectedProjectId,
				cliente: dados.current.contacts[0].clientes.find(cliente => parseInt(cliente.id) === parseInt(selectedClienteId)),
				responsavel: dados.current.contacts[0].person_responsables.find(resp => parseInt(resp.id) === parseInt(selectedResponsavelId)),
				projeto: dados.current.info.projetos.find(proj => proj.id === parseInt(selectedProjectId)),
				estado: estado,
				colaborador: [],
			};
		} else {
			const newId = dados.current.info.ticket.length > 0
				? dados.current.info.ticket[dados.current.info.ticket.length - 1].id + 1
				: 1;

			const selectedCliente = dados.current.contacts[0].clientes.find(cliente => parseInt(cliente.id) === parseInt(selectedClienteId));
			const selectedResponsavel = dados.current.contacts[0].person_responsables.find(resp => parseInt(resp.id) === parseInt(selectedResponsavelId));
			const selectedProjeto = dados.current.info.projetos.find(proj => proj.id === parseInt(selectedProjectId));
			setEmailResponsavel(selectedResponsavel ? selectedResponsavel.email : '');
			const ticketToAdd = {
				id: newId,
				prioridade: prioridade,
				data: getCurrentDateTime(),
				descricao: assuntoInput,
				clienteId: selectedClienteId,
				responsavelId: selectedResponsavelId,
				cliente: selectedCliente,
				responsavel: selectedResponsavel,
				projetoId: selectedProjectId,
				projeto: selectedProjeto,
				estado: false,
				colaborador: [],

			};
			enviarEmail(ticketToAdd);
			setEmailResponsavel(selectedResponsavel ? selectedResponsavel.email : '')
			dados.current.info.ticket.push(ticketToAdd);
		}

		setModalPedidoAssistencia(false);
	};

	const getCurrentDateTime = () => {
		const today = new Date();
		const day = String(today.getDate()).padStart(2, '0');
		const month = String(today.getMonth() + 1).padStart(2, '0');
		const year = today.getFullYear();
		const hours = String(today.getHours()).padStart(2, '0');
		const minutes = String(today.getMinutes()).padStart(2, '0');
		const seconds = String(today.getSeconds()).padStart(2, '0');

		return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
	};

	const EditTicket = (ticketId) => {
		const ticketToEdit = dados.current.info.ticket.find(ticket => ticket.id === ticketId);

		if (ticketToEdit) {
			setNewTicket({
				id: ticketToEdit.id,
				prioridade: ticketToEdit.prioridade,
				data: ticketToEdit.data,
				descricao: ticketToEdit.descricao,
				clienteId: ticketToEdit.clienteId,
				responsavelId: ticketToEdit.responsavelId,
				projetoId: ticketToEdit.projetoId,
				estado: ticketToEdit.estado,
			});

			setSelectedClienteId(ticketToEdit.clienteId);
			setSelectedResponsavelId(ticketToEdit.responsavelId);
			setSelectedProjectId(ticketToEdit.projetoId);
			setModalPedidoAssistencia(true);
		} else {
			console.error(`Ticket with ID ${ticketId} not found.`);
		}
	};

	const DeleteTicket = (ticketId) => {
		const updatedTickets = dados.current.info.ticket.filter(ticket => ticket.id !== ticketId);

		dados.current.info.ticket = updatedTickets;
		setTickets(updatedTickets);
	};

	/*   MÉTODOS DOS PROJETOS            */

	const AddProjeto = () => {
		// Verifica se `dados.current.info.projetos` está definido como um array, caso contrário, inicializa-o
		if (!dados.current.info) {
			dados.current.info = {}; // Inicializa info se não existir
		}

		if (!Array.isArray(dados.current.info.projetos)) {
			dados.current.info.projetos = []; // Inicializa projetos como um array se não estiver definido
		}

		// Determina o valor do próximo ID
		let newId = 1;
		if (dados.current.info.projetos.length > 0) {
			const lastProject = dados.current.info.projetos[dados.current.info.projetos.length - 1];
			newId = lastProject.id + 1;
		}

		// Se estamos editando um projeto existente
		if (projetoAtual) {
			const projetoIndex = dados.current.info.projetos.findIndex(proj => proj.id === projetoAtual.id);
			if (projetoIndex !== -1) {
				// Atualiza o projeto existente com os novos valores dos campos do modal
				dados.current.info.projetos[projetoIndex] = {
					id: dados.current.info.projetos[projetoIndex].id, // mantém o mesmo id
					codProjeto: codProjetoInput,
					nome: [{
						tipo: tipoSw.find(tipo => tipo.id === tipoIdInput),
						linha: linhaSw.find(linha => linha.id === linhaIdInput),
					}],
					nLicenca: nLicencaInput,
					dataInicio: dataInicioInput,
					dataFim: dataFimInput,
					assistenciaRemota: assistenciaRemotaInput,
					tempoAssistencia: tempoAssistenciaInput,
					assistenciaPermitida: assistenciaPermitidaInput,
				};
			}
		} else {
			// Se não estamos editando, adiciona um novo projeto
			const novoProjeto = {
				id: newId, // Define o novo ID
				codProjeto: codProjetoInput,
				nome: [{
					tipo: tipoSw.find(tipo => tipo.id === tipoIdInput),
					linha: linhaSw.find(linha => linha.id === linhaIdInput),
				}],
				nLicenca: nLicencaInput,
				dataInicio: dataInicioInput,
				dataFim: dataFimInput,
				assistenciaRemota: assistenciaRemotaInput,
				tempoAssistencia: tempoAssistenciaInput,
				assistenciaPermitida: assistenciaPermitidaInput,
			};
			// Adiciona o projeto ao array de projetos
			dados.current.info.projetos.push(novoProjeto);
			console.log("Novo Projeto Adicionado:", novoProjeto);
		}

		// Limpa os campos após adicionar ou editar
		clearModalFields();

		// Fecha o modal
		setIsProjectModalOpen(false);
	};

	const EditProjeto = (id) => {
		const projeto = dados.current.info.projetos.find(proj => proj.id === id);
		if (projeto) {
			setProjetoAtual(projeto); // Armazena o projeto atual para edição
			setCodProjetoInput(projeto.codProjeto);
			setTipoIdInput(projeto.nome[0].tipo.id);
			setLinhaIdInput(projeto.nome[0].linha.id);
			setNLicencaInput(projeto.nLicenca);
			setDataInicioInput(projeto.dataInicio);
			setDataFimInput(projeto.dataFim);
			setAssistenciaRemotaInput(projeto.assistenciaRemota);
			setTempoAssistenciaInput(projeto.tempoAssistencia);
			setAssistenciaPermitidaInput(projeto.assistenciaPermitida);
			setIsProjectModalOpen(true); // Abre o modal para edição
		} else {
			console.log("Projeto não encontrado");
		}
	};

	const DeleteProjeto = (id) => {
		const index = dados.current.info.projetos.find(proj => proj.id === id);

		if (index !== -1) {
			dados.current.info.projetos.pop(index, 1);
		} else {
			console.log("Projeto não encontrado:", id);
		}
		setRefresh(refresh + 1);
	}
	const clearModalFields = () => {
		setCodProjetoInput('');
		setTipoIdInput(1);
		setLinhaIdInput(1);
		setNLicencaInput('');
		setDataInicioInput('');
		setDataFimInput('');
		setAssistenciaRemotaInput(false);
		setTempoAssistenciaInput('');
		setAssistenciaPermitidaInput(false);
		setProjetoAtual(null); // Reseta o projeto atual
	};

	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////}

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {

		set_villages([])

		obter_freguesias_por_cidade(e.value, set_villages)

		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);
	}

	/*
	const change_identification_type = e => {
		set_dados(dados.current.info.identification.tipo_identificacao = e.value);
	}

	const change_district_by_city = async e => {

		return await obter_distrito_por_cidade(e.value)
			.then(res =>
				change_district({ value: res })
			).catch(() => { return } 
				//alert('Distrito não encontrado!')
			)
	}

	const handleProjectNameChange = (selectedName) => {
		console.log(`Escolhemos o projeto :  ${selectedName}`);

	};
	*/

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {

				if (res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}
				/*
				res.data[0].contacts[0]['person_responsables'] = [
					{ id: 1, name: 'Duarte Correia', email: 'duarte.correia332@outlook.com', mobile_phone: '962348291', resp: 'ASSEC', observation: '', departamentos: [1], },
					{ id: 2, name: 'Joana Mendes', email: 'joanamendes@email.com', mobile_phone: '963450382', resp: 'ASSEC', observation: '', departamentos: [2, 4] },
					{ id: 3, name: 'Mariana Pereira', email: 'marianapereira@email.com', mobile_phone: '964560473', resp: 'ASSEC', observation: '', departamentos: [3, 5] },
					{ id: 4, name: 'Vitor Martins', email: 'vitormartins@email.com', mobile_phone: '965670584', resp: 'ASSEC', observation: '', departamentos: [4, 6] },
					{ id: 5, name: 'Maria Domingues', email: 'mariadomingues@email.com', mobile_phone: '966780695', resp: 'ASSEC', observation: '', departamentos: [5, 7] },
					{ id: 6, name: 'Tânia Matias', email: 'taniamatias@email.com', mobile_phone: '967890716', resp: 'ASSEC', observation: '', departamentos: [6, 8] },
					{ id: 7, name: 'Júlio Salcedas', email: 'juliosalcedas@email.com', mobile_phone: '968900827', resp: 'ASSEC', observation: '', departamentos: [7, 9] },
					{ id: 8, name: 'Ricardo Almeida', email: 'ricardoalmeida@email.com', mobile_phone: '969010938', resp: 'ASSEC', observation: '', departamentos: [8, 10] },
					{ id: 9, name: 'Tiago Fernandes', email: 'tiagofernandes@email.com', mobile_phone: '960120049', resp: 'ASSEC', observation: '', departamentos: [9, 11] },
					{ id: 10, name: 'Catarina Nunes', email: 'catarinanunes@email.com', mobile_phone: '961230150', resp: 'ASSEC', observation: '', departamentos: [10, 12] },
					{ id: 11, name: 'Bruno Rodrigues', email: 'brunorodrigues@email.com', mobile_phone: '962340261', resp: 'ASSEC', observation: '', departamentos: [1, 11] },
					{ id: 12, name: 'Sofia Oliveira', email: 'sofiaoliveira@email.com', mobile_phone: '963450372', resp: 'ASSEC', observation: '', departamentos: [1, 12] },
					{ id: 13, name: 'David Fernandes', email: 'smokasmetin2@gmail.com', mobile_phone: '969348291', resp: 'ASSEC', observation: '', departamentos: [1, 2, 3, 6] },
				],
				*/

				res.data[0].contacts[0]['colaborador'] = [
					{ id: 1, nome: 'David Fernandes', email: 'davidfernandes@email.com', mobile_phone: '962348291', descricao: '', tickets: [] },
					{ id: 2, nome: 'Duarte Correia', email: 'duartecorreia@email.com', mobile_phone: '963450382', descricao: '', tickets: [] },]


				set_dados(dados.current = res.data[0]);
				//console.log(res)

			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}
	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props
	useEffect(() => {

		clean_data();
		obter_paises_em_pt(set_countries);


		if (getTokenInfo().profile === 'Cliente') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {


				//console.log(dados.current)
				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					setLoading(false);
				}
				else {
					set_show_district_city_village('d-none')
					setLoading(false);
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						setLoading(false);
					}
					else {
						set_show_district_city_village('d-none')
						setLoading(false);
					}
				})
				return
			}
		}
		catch {

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPUT(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								// props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})
		}
	}

	/*const handleSubmitVat = async e => {
		e.preventDefault();

		setLoading(true);
		get_vat_info(dados.current.info.vat)
			.then(res => {
				//console.log('---------- VAT INFO --------------')
				//console.log(res)

				if ((res.data.name !== '---') && (res.data.name !== '')) {
					clean_data();
					set_dados(dados.current.info.vat = res.data.vatNumber);
					set_dados(dados.current.info.name = res.data.name);
					set_dados(dados.current.addresses[0].address_detail = res.data.address);

					let aMorada = res.data.address.split("\n");
					// Verificar se pais é PT
					if (res.data.countryCode === 'pt') {
						//console.log('----------------------> É PT')

						change_country({ value: 'Portugal' })


						set_dados(dados.current.addresses[0].street_name = aMorada[1]);

						let city = aMorada[1];
						if (city !== undefined) {
							city = city.toLowerCase();
							city = city.charAt(0).toUpperCase() + city.slice(1);
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))


							// After District -> City
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))

							let aMoradaCP = aMorada[2].split(" ");
							set_dados(dados.current.addresses[0].postal_code = aMoradaCP[0]);
						}
					} else {
						//console.log('---------------------->NÃO È PT')
						set_dados(dados.current.addresses[0].street_name = aMorada[1]);
					}
				}
				else {

					Swal.fire('VAT não encotrado na base VIES.', '', 'info')

				}
				setLoading(false)
			})

			.catch(error => { setLoading(false); alert(error) });
	}*/

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							/* alert(res.status === 200 ?
								'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); */

							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};


	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.addresses[addresses_index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info[name] = value)

		if ((is_edit === false) && (name === 'vat')) {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type)
			}
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password !== '' && value === new_password) {

			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {

			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.contacts[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info_identification = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info.identificacao[name] = value)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">
						{dados.current.id !== '' && dados.info && dados.info.name
							? `${language[lang].entity} - ${dados.info.name}`
							: language[lang].entity
						}
					</h2>
					<p>
						{dados.current.id !== ''
							? language[lang].entity_edit
							: language[lang].entity_new
						}
					</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-3">
												<div className="row mb-4">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].name}</label>
														<input
															type="text"
															name="name"
															value={dados.current.info.name}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															placeholder={language[lang].name_placeholder}
															onChange={handle_change_info}
															required
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].email}</label>
														<input
															type="email"
															pattern={pattern_email}
															name="email"
															value={dados.current.info.email || dados.current.contacts[0].email}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															placeholder={language[lang].email_placeholder}
															onChange={handle_change_contacts}
														/>
													</div>
												</div>

												<div className='row mb-4'>
													<div className="col-md-3 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].entity_type}</label>
														<Select
															className="div-select"
															options={entity_types}
															name="client_type"
															value={dados.current.info.entity_type === '' ? null : { label: dados.current.info.entity_type, value: dados.current.info.entity_type }}
															placeholder={language[lang].type_placeholder}
															onChange={change_entity_type}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].validade_identificacao}</label>
														<input
															type="date"
															name="validade"
															value={dados.current.info.validade_identificacao !== '' ? dados.current.validade_identificacao : ''}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															onChange={handle_change_info}
														/>
													</div>

													<div className="col-md-4 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].observacao}</label>
														<textarea
															type="text"
															name="observation"
															value={dados.current.info.observation}
															placeholder={language[lang].observacao_placeholder}
															className="form-control form-control-lg mb-3 rounded-0 input-spacing"
															onChange={handle_change_info}
														/>
													</div>

													{/*
												<div className="row mb-5 d-none">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].type_identification}</label>
														
														<Select
															className="div-select"
															options={identification_types}
															name="identification_type"
															value={dados.current.info.identification.tipo_identificacao === '' ? null : { label: dados.current.info.identification.tipo_identificacao, value: dados.current.info.identification.tipo_identificacao }}
															placeholder={language[lang].type_identification_placeholder}
															onChange={change_identification_type}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_number}</label>
														<input type="text" pattern="\d*" inputMode='numeric' maxLength="11" name="numero_identificacao" value={dados.current.info.identification.numero_identificacao} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].identification_number_placeholder} onChange={handle_change_info_identification} />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_validation}</label>
														<input type="date" name="validade_identificacao" value={dados.current.info.identification.validade_identificacao !== '' ? dados.current.info.identification.validade_identificacao : ''} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" onChange={handle_change_info_identification} /> 
													</div>
												</div>
												*/}

													<div className="row mb-3">
														<div className="col-md-4">
															<label className="fs-5 fw-bold mb-2">{language[lang].tlm}</label>
															<PhoneInput
																defaultCountry="PT"
																className="form-control form-control-lg mb-3 rounded-0"
																placeholder={language[lang].tlm_placeholder}
																value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
																onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)}
															/>
														</div>

														<div className="col-md-4">
															<label className="fs-5 fw-bold mb-2">{language[lang].vat}</label>
															<input
																type="text"
																pattern={pattern_vat}
																minLength="9"
																inputMode="numeric"
																name="vat"
																value={dados.current.info.vat}
																className="form-control form-control-lg mb-3 rounded-0 input-spacing"
																placeholder={language[lang].vat_placeholder}
																onChange={handle_change_info}
																required
															/>
														</div>

														<div className="col-md-4 d-none">
															<label className="fs-5 fw-bold mb-2">{language[lang].birthday}</label>
															<input
																type="date"
																name="birthday"
																value={dados.current.info.birthday !== '' ? dados.current.info.birthday : ''}
																className="form-control form-control-lg mb-3 rounded-0 input-spacing"
																onChange={handle_change_info}
															/>
														</div>
													</div>

													<div className="row mb-5 d-none">
														<div className="col-md-4">
															<label className="fs-5 fw-bold mb-2">{language[lang].tlf}</label>
															<PhoneInput
																defaultCountry="PT"
																className="form-control form-control-lg mb-3 rounded-0 input-spacing"
																placeholder={language[lang].tlf_placeholder}
																value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
																onChange={e => set_dados(prev => ({ ...prev, current: { ...prev.current, contacts: [{ ...prev.current.contacts[0], phone: e }] } }))}
															/>
														</div>
													</div>

													<div className="row mb-3 d-none">												
														<div className="col-md-4">
															<label className="fs-5 fw-bold mb-2">{language[lang].observacao}</label>
															<textarea
																type="text"
																name="observation"
																value={dados.current.contacts.observation}
																placeholder={language[lang].observacao_placeholder}
																className="form-control form-control-lg mb-3 rounded-0"
																rows="2"
																onChange={handle_change_contacts}
															/>
														</div>
													</div>

													<div className="card-header border-0">
														<div className="card-title m-0">
															<h3 className="fw-bolder m-0">{language[lang].local_data}</h3>
														</div>
													</div>

													<div className="card-body p-4">
														<div className="row mb-3">
															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">{language[lang].country}</label>
																<Select
																	className="div-select"
																	options={countries}
																	name="pais"
																	value={
																		dados.current.addresses[0].country === ""
																			? null
																			: { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }
																	}
																	placeholder={language[lang].country_placeholder}
																	onChange={change_country}
																	styles={custom_select_styles}
																/>
															</div>

															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">{language[lang].district}</label>
																<Select
																	className="div-select"
																	options={districts}
																	name="distrito"
																	value={
																		dados.current.addresses[0].region === ""
																			? null
																			: { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }
																	}
																	placeholder={language[lang].district_placeholder}
																	onChange={change_district}
																	styles={custom_select_styles}
																/>
															</div>

															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">{language[lang].city}</label>
																<Select
																	className="div-select"
																	options={cities}
																	name="concelho"
																	value={
																		dados.current.addresses[0].city === ""
																			? null
																			: { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }
																	}
																	placeholder={language[lang].city_placeholder}
																	onChange={change_city}
																	styles={custom_select_styles}
																/>
															</div>
														</div>

														<div className="row mb-3">
															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">{language[lang].village}</label>
																<Select
																	className="div-select"
																	options={villages}
																	name="freguesia"
																	value={
																		dados.current.addresses[0].village === ""
																			? null
																			: { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }
																	}
																	placeholder={language[lang].village_placeholder}
																	onChange={change_village}
																	styles={custom_select_styles}
																/>
															</div>

															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">{language[lang].local}</label>
																<input
																	type="text"
																	name="localidade"
																	value={dados.current.addresses[0].localidade}
																	className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].local_placeholder}
																	onChange={handle_change_addresses}
																/>
															</div>

															<div className="col-md-4">
																<label className="fs-5 fw-bold mb-2">{language[lang].postal_code}</label>
																<input
																	type="text"
																	name="postal_code"
																	value={dados.current.addresses[0].postal_code}
																	className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
																	placeholder={language[lang].postal_code_placeholder}
																	onChange={handle_change_addresses}
																/>
															</div>
														</div>

														<div className="row mb-3">
															<div className="col-md-6">
																<label className="fs-5 fw-bold mb-2">{language[lang].morada}</label>
																<textarea
																	name="address_detail"
																	value={dados.current.addresses[0].address_detail}
																	className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
																	rows="4"
																	onChange={handle_change_addresses}
																/>
															</div>

															<div className="col-md-6">
																<label className="fs-5 fw-bold mb-2">{language[lang].observacao}</label>
																<textarea
																	type="text"
																	name="observation"
																	value={dados.current.addresses.observation}
																	placeholder={language[lang].observacao_placeholder}
																	className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" 
																	rows="4"
																	onChange={handle_change_addresses}
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
								
								{/* // PARTE DO SOFTWARE */}
								<div>
									<div className="cart mt-5">
										<div className="card-header border-0 d-flex justify-content-between align-items-center" aria-expanded="true" aria-controls="div_entidade_assistencia">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].adicionar_projeto}</h3>
											</div>
											<button
												type="button"
												onClick={() => setIsProjectModalOpen(true)}
												className="btn btn-default btn-sm"
											>
												{language[lang].assistencia_projeto}
											</button>
										</div>
										{/* Projetos */}
										<div className="col-md-12">
											<table className="table" style={{ width: '100%' }}>
												<thead>
													<tr>
														<th>Nº</th>
														<th>Nome</th>
														<th style={{ textAlign: 'right' }}>Ações</th>
													</tr>
												</thead>
												<tbody>
													{dados.current && dados.current.info && Array.isArray(dados.current.info.projetos) && dados.current.info.projetos.length > 0 ? (
														dados.current.info.projetos.map((projeto) => (
															<tr key={projeto.id}>
																<td>{projeto.id}</td>
																<td>
																	{projeto.nome && projeto.nome[0] && projeto.nome[0].tipo && projeto.nome[0].linha
																		? `${projeto.nome[0].tipo.nome} ${projeto.nome[0].linha.nome}`
																		: 'Nome do Projeto Indisponível'}
																</td>
																<td style={{ textAlign: 'right' }}>
																	<button
																		type="button"
																		onClick={() => EditProjeto(projeto.id)}
																		aria-label={`Editar o projeto ${projeto.id}`}
																		className="btn btn-default btn-sm"
																	>
																		✏️
																	</button>
																	<button
																		type="button"
																		onClick={() => {
																			if (window.confirm('Tem certeza que deseja apagar este projeto?')) {
																				DeleteProjeto(projeto.id);
																			}
																		}}
																		aria-label={`Apagar o projeto ${projeto.id}`}
																		className="btn btn-default btn-sm"
																	>
																		🗑️
																	</button>
																</td>
															</tr>
														))
													) : (
														<tr>
															<td colSpan="3">Nenhum projeto disponível</td>
														</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>
									{/* Adicionar Projetos Modal */}
									{isProjectModalOpen && (
										<div
											className="modal show d-flex justify-content-center align-items-center"
											style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
										>
											<div className="modal-dialog" style={{ maxWidth: '700px', width: '90%' }}>
												<div className="modal-content">
													<div className="modal-header">
														<h5 className="modal-title">Novo Projeto</h5>
														<button
															type="button"
															className="close"
															onClick={() => setIsProjectModalOpen(false)}
														>
															&times;
														</button>
													</div>
													<div className="modal-body">
														<div className="mb-3">
															<label className="w-100">
																Código do Projeto
																<input
																	type="text"
																	className="form-control mt-2"
																	value={codProjetoInput}
																	placeholder="Código do Projeto"
																	onChange={(e) => setCodProjetoInput(e.target.value)}
																	style={{ width: '100%' }}
																/>
															</label>
														</div>
														<div className="mb-3">
															<label className="w-100">
																Tipo de Software
																<select
																	className="form-control mt-2"
																	value={tipoIdInput}
																	onChange={(e) => setTipoIdInput(parseInt(e.target.value))}
																	style={{ width: '100%' }}
																>
																	{tipoSw.map((tipo) => (
																		<option key={tipo.id} value={tipo.id}>
																			{tipo.nome}
																		</option>
																	))}
																</select>
															</label>
														</div>
														<div className="mb-3">
															<label className="w-100">
																Linha de Software
																<select
																	className="form-control mt-2"
																	value={linhaIdInput}
																	onChange={(e) => setLinhaIdInput(parseInt(e.target.value))}
																	style={{ width: '100%' }}
																>
																	{linhaSw.map((linha) => (
																		<option key={linha.id} value={linha.id}>
																			{linha.nome}
																		</option>
																	))}
																</select>
															</label>
														</div>
														<div className="mb-3">
															<label className="w-100">
																Licença
																<input
																	type="text"
																	className="form-control mt-2"
																	value={nLicencaInput}
																	placeholder="Número da Licença"
																	onChange={(e) => setNLicencaInput(e.target.value)}
																	style={{ width: '100%' }}
																/>
															</label>
														</div>
														<div className="mb-3">
															<label className="w-100">
																Data de Início
																<input
																	type="date"
																	className="form-control mt-2"
																	value={dataInicioInput}
																	onChange={(e) => setDataInicioInput(e.target.value)}
																	style={{ width: '100%' }}
																/>
															</label>
														</div>
														<div className="mb-3">
															<label className="w-100">
																Data de Fim
																<input
																	type="date"
																	className="form-control mt-2"
																	value={dataFimInput}
																	onChange={(e) => setDataFimInput(e.target.value)}
																	style={{ width: '100%' }}
																/>
															</label>
														</div>
														<div className="mb-3 d-flex">
															<div className="form-check me-3">
																<input
																	type="checkbox"
																	className="form-check-input"
																	checked={assistenciaRemotaInput}
																	onChange={(e) => setAssistenciaRemotaInput(e.target.checked)}
																	id="assistenciaRemota"
																/>
																<label className="form-check-label" htmlFor="assistenciaRemota">
																	Assistência Remota
																</label>
															</div>
															<div className="form-check">
																<input
																	type="checkbox"
																	className="form-check-input"
																	checked={assistenciaPermitidaInput}
																	onChange={(e) => setAssistenciaPermitidaInput(e.target.checked)}
																	id="assistenciaPermitida"
																/>
																<label className="form-check-label" htmlFor="assistenciaPermitida">
																	Assistência Permitida
																</label>
															</div>
														</div>
														<div className="mb-3">
															<label className="w-100">
																Tempo de Assistência
																<input
																	type="text"
																	className="form-control mt-2"
																	value={tempoAssistenciaInput}
																	placeholder="Tempo de Assistência"
																	onChange={(e) => setTempoAssistenciaInput(e.target.value)}
																	style={{ width: '100%' }}
																/>
															</label>
														</div>
													</div>
													<div className="modal-footer">
														<button
															type="button"
															className="btn btn-default"
															onClick={() => setIsProjectModalOpen(false)}
														>
															Cancelar
														</button>
														<button
															type="button"
															className="btn btn-default"
															onClick={() => {
																AddProjeto();
																setIsProjectModalOpen(false);
															}}
														>
															Adicionar
														</button>
													</div>
												</div>
											</div>
										</div>
									)}
								</div>
								{/*------------------------------------------------------- NOVO PROJETO - ASSISTENCIA ------------------------------------------------------------------------------*/}
								<div className="card mt-5">
									<div>
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].assistencia}</h3>
										</div>
										<div className="d-flex justify-content-between mt-3">
											<div>
												<button
													type="button"
													onClick={toggleTablePedidos}
													className="btn btn-default btn-sm me-2"
												>
													{language[lang].filter_resolver}
												</button>
												<button
													type="button"
													onClick={toggleTableConcluidos}
													className="btn btn-default btn-sm"
												>
													{language[lang].filter_concluido}
												</button>
											</div>
											<button
												type="button"
												onClick={() => setModalPedidoAssistencia(true)}
												className="btn btn-default btn-sm"
											>
												{language[lang].assistencia_botao}
											</button>
										</div>
									</div>
									<div className='row mb-6'>
										{tabelaPedidos && (
											<div className="row">
												<table className="table">
													<thead>
														<tr>
															<th>Nº</th>
															<th>Prioridade</th>
															<th>Data</th>
															<th>Cliente</th>
															<th>Software</th>
															<th>Assunto</th>
															<th>Responsável</th>
															<th>Ações</th>
														</tr>
													</thead>
													<tbody>
														{dados.current && dados.current.info && Array.isArray(dados.current.info.ticket) && dados.current.info.ticket.length > 0 ? (
															dados.current.info.ticket
																.filter(ticket => ticket.id != '' && ticket.estado === false)
																.slice()
																.sort((a, b) => {
																	const prioridadeDiff = a.prioridade - b.prioridade;
																	if (prioridadeDiff === 0) {
																		return new Date(a.data) - new Date(b.data);
																	}

																	return prioridadeDiff;
																})
																.map((ticket) => {

																	return (
																		<tr key={ticket.id}>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.id}</td>
																			<td style={{ backgroundColor: prioridadeMap[ticket.prioridade].color }} onClick={() => mostrarTicket(ticket.id)}>
																				{prioridadeMap[ticket.prioridade].name}
																			</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.data}</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.cliente ? ticket.cliente.nome : 'Indefinido'}</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>
																				{
																					ticket.projeto != undefined
																						? `${ticket.projeto.nome[0].tipo.nome} ${ticket.projeto.nome[0].linha.nome}`
																						: 'Nome do Projeto Indisponível'
																				}
																			</td>
																			<td onClick={() => mostrarTicket(ticket.id)} style={lineBreak}>
																				{ticket.descricao ? ticket.descricao : 'Descrição do Ticket Indisponível'}
																			</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.responsavel && ticket.responsavel.name ? ticket.responsavel.name : 'Indefinido'}</td>
																			<button type="button" onClick={() => EditTicket(ticket.id)}>✏️</button>
																			<button className="btn btn-default" onClick={() => DeleteTicket(ticket.id)}>🗑️</button>
																		</tr>
																	);
																})
														) : (
															<tr>
																<td colSpan={7}>Nenhum ticket disponível</td>
															</tr>
														)}

													</tbody>
												</table>
											</div>
										)}
										{tabelaConcluidos && (
											<div className="row">
												<table className="table">
													<thead>
														<tr>
															<th>Nº</th>
															<th>Data</th>
															<th>Cliente</th>
															<th>Software</th>
															<th>Assunto</th>
															<th>Responsável</th>
															<th>Solução</th>
															<th>Colaborador</th>
															<th>Ações</th>
														</tr>
													</thead>
													<tbody>
														{dados.current && dados.current.info && Array.isArray(dados.current.info.ticket) && dados.current.info.ticket.length > 0 ? (
															dados.current.info.ticket
																.filter(ticket => ticket.estado === true)
																.slice()
																.sort((a, b) => {
																	const prioridadeDiff = a.prioridade - b.prioridade;
																	if (prioridadeDiff === 0) {
																		return new Date(a.data) - new Date(b.data);
																	}

																	return prioridadeDiff;
																})
																.map((ticket) => {

																	return (
																		<tr key={ticket.id}>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.id}</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.data}</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.cliente ? ticket.cliente.nome : 'Indefinido'}</td>

																			<td onClick={() => mostrarTicket(ticket.id)}>
																				{
																					ticket.projeto != undefined
																						// Verifica se o ID do projeto é igual ao ID do ticket
																						? `${ticket.projeto.nome[0].tipo.nome} ${ticket.projeto.nome[0].linha.nome}`
																						: 'Nome do Projeto Indisponível'
																				}

																			</td>
																			<td onClick={() => mostrarTicket(ticket.id)} style={lineBreak}>{ticket.descricao ? ticket.descricao : 'Descrição do Ticket Indisponível'}</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>{ticket.responsavel && ticket.responsavel.name ? ticket.responsavel.name : 'Indefinido'}</td>
																			<td onClick={() => mostrarTicket(ticket.id)} style={lineBreak}>{ticket.solucao ? ticket.solucao : 'Solução do Ticket Indisponível'}</td>
																			<td onClick={() => mostrarTicket(ticket.id)}>
																				{ticket.colaborador && ticket.colaborador.nome ? ticket.colaborador.nome : 'Indefinido'}
																			</td>
																			<button className="btn btn-default" onClick={() => DeleteTicket(ticket.id)}>🗑️</button>
																		</tr>
																	);
																})
														) : (
															<tr>
																<td colSpan={7}>Nenhum ticket disponível</td>
															</tr>
														)}

													</tbody>
												</table>
											</div>
										)}
										{/* // Model responsavel depois de clicar no ticket */}
										{modalPedidoSolucao && (
											<div
												className="modal show d-flex justify-content-center align-items-center"
												style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
											>
												<div className="modal-dialog" style={{ maxWidth: '700px', width: '90%' }}>
													<div className="modal-content">
														<div className="modal-header">
															<h5 className="modal-title">Solução - Pedido de Assistência</h5>
															<button
																type="button"
																className="close"
																onClick={() => setModalPedidoSolucao(false)}
															>
																&times;
															</button>
														</div>
														<div className="modal-body">
															<div className="mb-3">
																<label>
																	Descrição do problema
																	<textarea
																		value={dados.current.info.ticket.find(ticket => ticket.id === selectedTicketId)?.descricao || ''}
																		onChange={(e) => setAssuntoInput(e.target.value)}
																		className="form-control mt-2"
																		readOnly
																		rows={8}
																		style={{ width: '100%', minWidth: '600px' }}
																	/>
																</label>
															</div>
															<div className="mb-3">
																<label>
																	Solução
																	<textarea
																		value={solucaoInput}
																		onChange={(e) => setSolucaoInput(e.target.value)}
																		className="form-control mt-2"
																		rows={8}
																		style={{ width: '100%', minWidth: '600px' }}
																	/>
																</label>
															</div>
															<div>
																{dados.current?.contacts?.[0]?.colaborador?.length > 0 ? (
																	<label className="w-100">Colaborador
																		<select
																			value={selectedColaboradorId}
																			onChange={(e) => setSelectedColaboradorId(e.target.value)}
																			className="form-control mt-2"
																		>
																			<option value="" disabled hidden>
																				Colaborador que solucionou o problema?
																			</option>
																			{dados.current.contacts[0].colaborador.map((colaborador) => (
																				<option key={colaborador.id} value={colaborador.id}>
																					{colaborador.nome}
																				</option>
																			))}
																		</select>
																	</label>
																) : (
																	<p>Nenhum colaborador disponível para seleção</p>
																)}
															</div>


														</div>
														<div className="modal-footer d-flex justify-content-end">
															<button
																type="button"
																className="btn btn-default ms-2"
																onClick={() => {
																	atualizarTicketEstado(ticketId, solucaoInput, selectedColaboradorId)
																}}
															>
																Ok
															</button>
															<button
																type="button"
																className="btn btn-default"
																onClick={() => setModalPedidoSolucao(false)}
															>
																Cancelar
															</button>
														</div>
													</div>
												</div>
											</div>
										)}
										{modalPedidoAssistencia && (
											<div
												className="modal show d-flex justify-content-center align-items-center"
												style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
											>
												<div className="modal-dialog" style={{ maxWidth: '700px', width: '90%' }}>
													<div className="modal-content">
														<div className="modal-header">
															<h5 className="modal-title">Software - Pedido de Assistência</h5>
															<button
																type="button"
																className="close"
																onClick={() => setModalPedidoAssistencia(false)}
															>
																&times;
															</button>
														</div>
														<div className="modal-body">
															<div className="mb-3 d-flex">
																<div style={{ flex: 1, marginRight: '20px' }}>
																	<div>
																		{dados.current?.contacts?.[0]?.clientes?.length > 0 ? (
																			<label className="w-100">Cliente
																				<select
																					value={selectedClienteId}
																					onChange={(e) => setSelectedClienteId(e.target.value)}
																					className="form-control mt-2"
																					onFocus={(e) => {
																						e.target.firstChild.disabled = true;
																					}}
																				>
																					<option value="" disabled selected hidden>
																						Selecione um Cliente
																					</option>
																					{dados.current.contacts[0].clientes.map((cliente) => (
																						<option key={cliente.id} value={cliente.id}>
																							{cliente.nome}
																						</option>
																					))}
																				</select>
																			</label>
																		) : (
																			<p>Selecione um cliente</p>
																		)}
																	</div>
																	<br></br>
																	<div>
																		<label className="w-100">Projeto</label>
																		<select
																			id="projetos"
																			value={selectedProjectId}
																			onChange={(e) => setSelectedProjectId(e.target.value)}
																			className="form-control mt-2"
																			onFocus={(e) => {
																				e.target.firstChild.disabled = true;
																			}}
																		>
																			<option value="" disabled selected hidden>
																				Selecione um Projeto
																			</option>
																			{dados.current && dados.current.info.projetos && dados.current.info.projetos.length > 0 ? (
																				dados.current.info.projetos.map((projeto) => (
																					<option key={projeto.id} value={projeto.id}>
																						{projeto.nome[0]?.tipo?.nome || 'Tipo Indisponível'} - {projeto.nome[0]?.linha?.nome || 'Linha Indisponível'}
																					</option>
																				))
																			) : (
																				<option disabled>Nenhum projeto disponível</option>
																			)}
																		</select>
																	</div>
																</div>
																<div className="me-3" style={{ flex: 1 }}>
																	<label className="form-label">Prioridade</label>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="1"
																				checked={prioridade === '1'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Imediato
																		</label>
																	</div>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="2"
																				checked={prioridade === '2'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Urgente
																		</label>
																	</div>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="3"
																				checked={prioridade === '3'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Pouco Urgente
																		</label>
																	</div>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="4"
																				checked={prioridade === '4'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Não Urgente
																		</label>
																	</div>
																</div>
															</div>
															<div className="mb-3">
																<label>
																	Assunto
																	<textarea
																		value={assuntoInput}
																		onChange={(e) => setAssuntoInput(e.target.value)}
																		className="form-control mt-2"
																		rows={8}
																		style={{ width: '100%', minWidth: '600px' }}
																	/>
																</label>
															</div>
															<div className="mb-3">
																{dados.current.contacts[0].person_responsables.length > 0 ? (
																	<label className="w-100">
																		Responsável
																		<select
																			value={selectedResponsavelId}
																			onChange={(e) => setSelectedResponsavelId(e.target.value)}
																			className="form-control mt-2"
																		>
																			{dados.current.contacts[0].person_responsables.map((responsavel) => (
																				<option key={responsavel.id} value={responsavel.id}>
																					{responsavel.name}
																				</option>
																			))}
																		</select>
																	</label>
																) : (
																	<p>Selecione um responsável</p>
																)}
															</div>
														</div>
														<div className="modal-footer">
															<button
																type="button"
																className="btn btn-default"
																onClick={() => {
																	addTicket();
																	setModalPedidoAssistencia(false);
																}}
															>
																Fazer pedido de assistência
															</button>
														</div>
													</div>
												</div>
											</div>
										)}
									</div>
								</div>

								{/*------------------------------------------------------- NOVO PROJETO - ASSISTENCIA ------------------------------------------------------------------------------*/}
								<div className="card mt-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_departamento">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
										</div>
									</div>
									<div id="div_entidade_departamento" className="collapse show">
										<form id="form_user" onSubmit={handleSubmitPassword}>

											<div className="card-body border-top p-4">

												<div className="row mb-6">
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].username}</label>
														<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password_confirmation}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_confirmation_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div>
												</div>

												<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form_user" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div >

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item" + ' ' + getTokenInfo().profile}>
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
